import React, { useCallback } from 'react';
import CheckMarker from 'oldAssets/images/icons/check-green.svg';
import styles from './CheckList.module.scss';

const CheckList = ({
  list,
  marker = CheckMarker,
  render
}) => {
  const defaultRender = useCallback((item) => {
    return (
      <li className={ styles.item } key={ item }>
        <img src={ marker } className={ styles.marker } />
        <span className={ styles.text }>{ item }</span>
      </li>
    );
  }, [marker]);

  const renderItem = render || defaultRender;

  return (
    <ul className={ styles.CheckList }>
      { list && list.map(renderItem) }
    </ul>
  );
};

export default CheckList;
